 $(".slick-slider").slick({
      slidesToShow: 4,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 60px;">&#8249;</span></button>',
      nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 60px;">&#8250;</span></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            prevArrow: '<button type="button" class="slick-prev testi-left-arro"><span style="font-size: 40px;">&#8249;</span></button>',
            nextArrow: '<button type="button" class="slick-next testi-right-arro"><span style="font-size: 40px;">&#8250;</span></button>',
          }
        },
        {
          breakpoint: 600, 
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
          }
        }
      ]
    });

/* blog slider*/

$(document).ready(function() {
  $('.blog-carousel').owlCarousel({
    items: 1, // Default number of items
    margin: 20,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    nav: true,
    dots: true,
    responsive: {
      0: { items: 1 },      
      600: { items: 1 },   
      1000: { items: 1 }    
    }
  });
});


/* instagram slider*/


setTimeout(function() {
  console.log('instagram slider here');
jQuery('div#insta-feed .instafeed-new-layout-wrapper').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    nav:false,
    autoplay:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
}, 5000);  


const changeText = () => {
  const loadMoreBtn = document.querySelector('a.yotpo-reviews-pagination-item.yotpo-vertical-pagination-item');
  if (loadMoreBtn && loadMoreBtn.textContent.trim() === "Load more reviews") {
    loadMoreBtn.textContent = "Show more reviews";
    clearInterval(checkExist); // Stop checking once it's updated
  }
};

const checkExist = setInterval(changeText, 500);




// see-similar-products slider

document.addEventListener('DOMContentLoaded', function () {
  
 if (window.innerWidth < 768) {
    const toggleBtns = document.querySelectorAll('.see-similar-toggle');
    const popup = document.querySelector('.see-similar-container');
  
    toggleBtns.forEach((toggleBtn) => {
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent immediate closing
        popup.classList.toggle('active');
      });
    });
  
    document.addEventListener('click', function (e) {
      
      const clickedOnToggle = Array.from(toggleBtns).some(btn => btn.contains(e.target));
      if (!popup.contains(e.target) && !clickedOnToggle) {
        popup.classList.remove('active');
      }
    });
  }
   $('.similar-slider-products').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: window.innerWidth < 1024,
    autoplaySpeed: 8000,
    prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24"><path d="M15 6l-6 6 6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24"><path d="M9 6l6 6-6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  // AJAX Add to Cart
  document.querySelectorAll('.similar-slider-products .ajax-add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const productId = this.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        localStorage.setItem('openCartDrawer', 'true');
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        setTimeout(() => location.reload(), 1000);
      })
      .catch(() => setTimeout(() => location.reload(), 1000));
    });
  });

  // Open cart drawer after reload
  if (localStorage.getItem('openCartDrawer') === 'true') {
    localStorage.removeItem('openCartDrawer');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
});



// pair_it_with_product_metafields slider

document.addEventListener('DOMContentLoaded', function () {
    var autoplayEnabled = window.innerWidth < 1024;
    
    $(".paired-slider").slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: autoplayEnabled,
      autoplaySpeed: 8000,
      prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24"><path d="M15 6l-6 6 6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24"><path d="M9 6l6 6-6 6" stroke="#1f5d7b" stroke-width="2" fill="none"/></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

  // AJAX Add to Cart with delayed reload and drawer open
  document.querySelectorAll('.paired-product-slider .ajax-add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const productId = this.dataset.productId;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productId, quantity: 1 })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(data => {
        // Set flag to open drawer after reload
        localStorage.setItem('openCartDrawer', 'true');

        // Optionally open drawer immediately
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Reload after 1 seconds
        setTimeout(() => {
          location.reload();
        }, 1000);
      })
      .catch(err => {
        console.error('Add to cart error:', err);
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    });
  });

  // On page load, open cart drawer if flag set
  if (localStorage.getItem('openCartDrawer') === 'true') {
    localStorage.removeItem('openCartDrawer');
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  }
});




document.addEventListener("DOMContentLoaded", function () {
  const ringSizeSelect = document.querySelector('select[name="options[Ring size]"]');
  const goldRadios = document.querySelectorAll('input[name="Gold"]');

  const btnDefault = document.querySelector(".btn-default");
  const btnAddToCart = document.querySelector(".btn-add-to-cart");
  const btnMadeToOrder = document.querySelector(".btn-made-to-order");
  const btnSoldOut = document.querySelector(".btn-sold-out");

  function hideAllButtons() {
    btnDefault.style.display = "none";
    btnAddToCart.style.display = "none";
    btnMadeToOrder.style.display = "none";
    btnSoldOut.style.display = "none";
  }

  function updateButtonState() {
    const selectedRing = ringSizeSelect?.selectedOptions[0];
    const selectedGold = [...goldRadios].find((radio) => radio.checked);

    // If either variant option is missing, show default button
    if (!selectedRing || !selectedGold) {
      hideAllButtons();
      btnDefault.style.display = "block";
      return;
    }

    // You can decide which variant to check (priority to Gold here)
    const policy = selectedGold.dataset.inventoryPolicy;
    const quantity = parseInt(selectedGold.dataset.inventoryQuantity, 10);

    hideAllButtons();

    if (policy === "deny" && quantity > 0) {
      btnAddToCart.style.display = "block";
    } else if (policy === "deny" && quantity <= 0) {
      btnSoldOut.style.display = "block";
    } else if (policy === "continue" && quantity <= 0) {
      btnMadeToOrder.style.display = "block";
    } else {
      btnDefault.style.display = "block"; // Fallback
    }
  }

  // Event listeners
  if (ringSizeSelect) {
    ringSizeSelect.addEventListener("change", updateButtonState);
  }

  goldRadios.forEach((radio) => {
    radio.addEventListener("change", updateButtonState);
  });

  // Initial call
  updateButtonState();
});